import { CourseOffer, OccurrenceOffer } from '@shared/types';
import { VoucherInput, VoucherInputProps } from '../../VoucherInput';
import { FunctionComponent } from 'react';

export type VouchersSectionProps = VoucherInputProps & {
    offers: (OccurrenceOffer | CourseOffer)[];
};

export const VouchersSection: FunctionComponent<VouchersSectionProps> = ({
    offers,
    courseId,
    educatorId,
    onVoucherSelected,
    origin,
}) => {
    const hasPaidOffers = offers.some((offer) => offer.price && offer.price > 0);

    if (!hasPaidOffers) {
        return null;
    }

    return (
        <VoucherInput
            courseId={courseId}
            educatorId={educatorId}
            onVoucherSelected={onVoucherSelected}
            origin={origin}
        />
    );
};
